<ng-container *ngIf="viewModel$ | async as viewModel; else loading">
    <div *ngIf="viewModel.isLoading">
        <div class="no-records">
            <h2>Loading...</h2>
        </div>
    </div>

    <div *ngIf="!viewModel.isLoading && !viewModel.assets.length">
        <div class="no-records">
            <h2>No Records Found</h2>
        </div>
    </div>

    <div class="select-all-bar" *ngIf="!viewModel.isLoading && viewModel.assets.length">
        <mat-checkbox (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()">
            Select All
        </mat-checkbox>
    </div>

    <div class="grid" *ngIf="!viewModel.isLoading && viewModel.assets.length">
        <mat-card appearance="outlined" *ngFor="let asset of viewModel.assets; let i = index">
            <mat-card-content>
                <div class="grid-col-span-2 offer-name" title="{{ asset.assetName }}" fxLayout="row wrap">
                    <mat-checkbox class="card-checkbox" (click)="$event.stopPropagation()" fxFlex="30px"
                        (change)="$event ? selection.toggle(asset) : null" [checked]="selection.isSelected(asset)">
                    </mat-checkbox>

                </div>
                <div fxLayoutAlign="center center" class="offer-image">
                    <div class="image-wrapper">
                        <img mat-card-md-image
                            [src]="asset | azureAssetPreview: PreviewMode.Medium"
                            alt="Asset Image" (error)="onImageError($event)">
                        <div class="watermark" *ngIf="asset.doNotUse">Do Not Use</div>
                    </div>
                </div>
                <div class="offer-content" fxLayout="column">
                    <div class="offer-headline" title="{{ asset.dateAdded }}">
                        <div class="ellipsis-3-line offer-headline-bold">{{ asset.assetName }}</div>
                        <span class="ellipsis-3-line">{{asset.dateAdded }}</span>
                    </div>
                    <div *ngIf="asset.assetGroupName">
                        <span class="ellipsis-3-line">{{ asset.assetGroupName }}</span>
                    </div>
                    <div *ngIf="asset.fileType">
                        <span class="ellipsis-3-line">{{ asset.fileType }}</span>
                    </div>
                    <div fxFlex fxLayout="row" fxLayoutAlign="end end">
                        <button class="offer-button" type="button" mat-button color="accent"
                            (click)="onEdit(asset, i)">Edit</button>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <mat-paginator [length]="viewModel.totalRecords" [pageSize]="viewModel.searchStateParams.pageSize"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 500]" (page)="onPage($event)"
        *ngIf="!viewModel.isLoading && viewModel.assets.length" showFirstLastButtons
        [pageIndex]="viewModel.searchStateParams.pageIndex">
    </mat-paginator>
</ng-container>

<ng-template #loading>
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>